import { DEFAULT_BG_COLOR as e } from "../../constants/default-styles.mjs";
import { useTranslation as t } from "../../i18n.mjs";
import { isImageSelected as n } from "../image-extension/utils/is-image-selected.mjs";
import { ColorPicker as r } from "../../components/color-picker/index.mjs";
import { ColorSwatchIcon as i } from "../../components/content-controls/color-swatch-icon.mjs";
import { useEditorState as a } from "@tiptap/react";
import { useMemo as o } from "react";
import { jsx as s } from "react/jsx-runtime";
import { normalizeToHex as c } from "@systemeio/util";
import { PaintPourIcon as l } from "@systemeio/icons";
//#region src/extensions/text-background-color-extension/use-text-background-color-extension-toolbar.tsx
var u = (u, d) => {
	let { t: f } = t(), { shouldHideTooltip: p, showAlpha: m = !0 } = d ?? {}, h = a({
		editor: u,
		selector: ({ editor: e }) => ({
			backgroundColor: e?.getAttributes("textStyle").backgroundColor,
			isEditable: e?.options.editable ?? !1,
			isImageSelected: n(e)
		})
	}), g = h?.backgroundColor, _ = g ? c(g) : e, v = !h?.isEditable || !!h?.isImageSelected;
	return o(() => {
		let e = (e) => /* @__PURE__ */ s(r, {
			applyLabel: f("global.apply"),
			clearDisabled: !g,
			clearLabel: f("global.clear"),
			color: _,
			disabled: v,
			label: f("background_color"),
			onApply: (e) => u?.chain().focus().setBackgroundColor(e).run(),
			onClear: () => u?.chain().focus().unsetBackgroundColor().run(),
			onPreview: (e) => u?.chain().setBackgroundColor(e).run(),
			showAlpha: m,
			asSheetRow: e,
			showTooltip: !p,
			children: /* @__PURE__ */ s(i, {
				color: g ? _ : void 0,
				children: /* @__PURE__ */ s(l, {})
			})
		});
		return {
			toolbarRender: e(!1),
			sheetRender: e(!0)
		};
	}, [
		_,
		u,
		g,
		v,
		p,
		m,
		f
	]);
};
//#endregion
export { u as useTextBackgroundColorExtensionToolbar };
